import axios from 'axios';
import { pick } from 'lodash';

const defaultState = {
    parameters: {}, // The parameters in the search bar
    agency: {},
    branches: [],
    fetched: null, // Date Time
    fetching: true,
    allowedEmpCandTypes: ['emp','cnd'],
    additionalServices: {
        'emp': {
            'interviewsuites': 'Interview Suites',
            'psychometrictesting': 'Psychometric Testing',
            'salarysurveys': 'Salary Surveys'
        },
        'cnd': {
            'cvassist': 'Assistance with CV preparation',
            'joblist': 'Jobs Listed On Website',
            'interview': 'Interview skills coaching',
            'permits': 'Assistance with Work Permits / Visa\'s',
            'salarysurveys': 'Salary Surveys',
            'jobalert': 'Job Alert E-Mails'
        }
    },
    recruitmentLevels: {
        'schoolleaver': 'School Leaver',
        'graduate3to6': 'Regular',
        'traineeapprentice': 'Trainee',
        'graduate18plus': 'Graduate',
        'graduate18to3': 'Junior',
        'graduate6plus': 'Senior',
        'director': 'Director',
        'seniormanager': 'Senior Manager',
        'manager': 'Manager',
        'teamleader': 'Team Leader'
    },
    recruitmentTypes: {
        'contract': 'Contract',
        'permanent': 'Permanent',
        'temporary': 'Temporary',
        'parttimejobshare': 'Part Time'
    }

};

const getters = {

    // probably never get used but leave for now.
    personalPageURL(state) {
        return state.agency.personal_page_url;
    },

    showEmployerInfo(state) {
        return state.parameters.emp_cand == 'emp' ||
            !state.allowedEmpCandTypes.includes(state.parameters.emp_cand);
    },

    showCandidateInfo(state) {
        return state.parameters.emp_cand == 'cnd' ||
            !state.allowedEmpCandTypes.includes(state.parameters.emp_cand);
    },

    hasAdditionalServicesForEmployers(state) {
        return state.agency.AdditionalServicesForEmployers.split(/,/).filter(r => r !== '').length > 0;
    },

    hasAdditionalServicesForCandidates(state) {
        return state.agency.AdditionalServicesForCandidates.split(/,/).filter(r => r !== '').length > 0;
    },

    additionalServicesFor: (state) => (type) => {
        return state.additionalServices[type];
    },

    additionalServicesList: (state, getters) => (type,services) => {
        let l = getters.additionalServicesFor(type);
        return pick(l, services.split(/,/));
    },

    getRecruitedLevels: (state) => (levels) => {
        return pick(state.recruitmentLevels, levels.split(/,/));
    },

    hasRecruitedLevels: (state, getters) => (levels) => {
        let l = _.keys(getters.getRecruitedLevels(levels));
        return l.length > 0;
    },

    hasRecruitedIndustries: (state) => {
        return state.agency.industries != '';
    },

};

const actions = {
    async loadInfo({ state, commit, dispatch }, location) {
        console.log(location);

        if (!state.fetching) {
            console.log('PP: Not in fetching state');
            return false;
        }

        return new Promise(async (resolve, reject) => {
            console.log('PP: Performing load as we need to fetch');
            commit('setFetching');

            let apiURL = "/api" + location.pathname + location.search;
            console.log(apiURL);

            axios
                .get(apiURL)
                .then((response) => {
                    console.log(response.data);
                    // this overwrites the entire state in one go, it might need updating
                    commit('setState', response.data.agency);
                    dispatch('pagetext/updateState', response.data.pagetext, { root: true });
                    resolve();
                    commit('setFetching', false);
                    commit('setFetched', new Date());
                })
                .finally(() => {
                });

        });
    }
};

const mutations = {
    setFetched(state, fetched) {
        state.fetched = fetched;
    },
    setFetching(state, fetching = true) {
        state.fetching = fetching;
    },
    setState(state, newState) {
        Object.assign(state, newState);
    },
    resetState(state) {
        Object.assign(state, defaultState);
    }
};

export default {
    namespaced: true,
    getters,
    actions,
    mutations,
    state: defaultState
};
